import { render } from "./BtnReiniciarIntegracaoEmLote.vue?vue&type=template&id=481fd485"
import script from "./BtnReiniciarIntegracaoEmLote.vue?vue&type=script&lang=js"
export * from "./BtnReiniciarIntegracaoEmLote.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__